export default {"src":"/_next/static/media/chevronRight.f5a92c3b.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};